import AsyncStorage from '@react-native-async-storage/async-storage';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import {
  CustomerFilters,
  DEFAULT_CUSTOMER_FILTERS,
} from '@finance-hub/domain/customers/blocs/types/customer-list';

export const CUSTOMER_FILTER_STORAGE_KEY = 'finance_hub_customer_filters';

interface CustomerFilterStore {
  applyFilters: (filters: CustomerFilters) => void;
  filters: CustomerFilters;
}

export const useCustomerFilterStore = create<CustomerFilterStore>()(
  persist(
    (set) => ({
      applyFilters: (filters) => set({ filters }),
      filters: DEFAULT_CUSTOMER_FILTERS,
    }),
    {
      merge: (persisted, current) => ({
        ...current,
        filters: {
          ...current.filters,
          ...(persisted as Partial<CustomerFilterStore> | undefined)?.filters,
        },
      }),
      name: CUSTOMER_FILTER_STORAGE_KEY,
      partialize: (state) => ({ filters: state.filters }),
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);
